var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: { title: "编辑规则", width: 700, visible: _vm.visible },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "指标项", prop: "pointId" } },
            [
              _c("a-tree-select", {
                staticStyle: { width: "100%" },
                attrs: {
                  "tree-data": _vm.treeData.indexIetmTree,
                  "search-placeholder": "请选择指标项",
                },
                model: {
                  value: _vm.form.pointId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "pointId", $$v)
                  },
                  expression: "form.pointId",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "规则名称", prop: "name" } },
            [
              _c("a-input", {
                attrs: { allowClear: "" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "题目", prop: "questionIds" } },
            [
              _c("a-tree-select", {
                staticStyle: {
                  width: "100%",
                  "max-height": "210px",
                  "overflow-y": "auto",
                },
                attrs: {
                  dropdownStyle: { maxHeight: "210px" },
                  "tree-data": _vm.treeData.topicTree,
                  "tree-checkable": "",
                  "show-checked-strategy": _vm.SHOW_PARENT,
                  "search-placeholder": "请选择题目",
                },
                model: {
                  value: _vm.form.questionIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "questionIds", $$v)
                  },
                  expression: "form.questionIds",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "计算方式", prop: "type" } },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: 1 } }, [
                    _vm._v("合计"),
                  ]),
                  _c("a-select-option", { attrs: { value: 2 } }, [
                    _vm._v("其中一项"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "规则", prop: "maxScore" } },
            [
              _c(
                "a-input-group",
                { attrs: { compact: "" } },
                [
                  _c("a-input-number", {
                    staticStyle: { width: "100px", "text-align": "center" },
                    attrs: { placeholder: "最小值" },
                    model: {
                      value: _vm.form.minScore,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "minScore", $$v)
                      },
                      expression: "form.minScore",
                    },
                  }),
                  _c("a-input", {
                    staticStyle: {
                      width: "30px",
                      "border-left": "0",
                      "pointer-events": "none",
                      background: "#fff",
                    },
                    attrs: { placeholder: "~", disabled: "" },
                  }),
                  _c("a-input-number", {
                    staticStyle: {
                      width: "100px",
                      "text-align": "center",
                      "border-left": "0",
                    },
                    attrs: { placeholder: "最大值" },
                    model: {
                      value: _vm.form.maxScore,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "maxScore", $$v)
                      },
                      expression: "form.maxScore",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "结果分析" } },
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.openRichTextModal("resultAnalysis")
                    },
                  },
                },
                [_vm._v("\n        结果分析 - 富文本编辑\n      ")]
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "建议" } },
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.openRichTextModal("suggestion")
                    },
                  },
                },
                [_vm._v("\n        建议 - 富文本编辑\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("InventoryRichModal", {
        ref: "InventoryRichModalRef",
        on: { handleOk: _vm.richTextHandleOk },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }